export default __webpack_public_path__ + "static/media/vip-9.4b6d282e.gif";